import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-3 py-3 sm:px-4 sm:py-4" data-id="element-31" data-mp="1hcrwc7ansus8">
      <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="1hb8ewdd9odov">
        <h2 className="mb-1.5 text-center font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-33" data-mp="1cf9mmeotibj6">
          Frequently Asked Questions
        </h2>
        <div className="space-y-1" data-id="element-34" data-mp="253f8x5vis8l4">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <article key={faq.question} className="overflow-hidden rounded-lg border border-eq-line bg-eq-light" data-id="element-35" data-mp="1v581per194wb" data-mpi={index}>
                <h3 data-id="element-36" data-mp="omt1twdp45g6">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-2 px-2.5 py-2 text-left" aria-expanded={isOpen} aria-controls={panelId} data-id="element-37" data-mp="jpsxbpwhvar6">
                    <span className="font-display text-[12.5px] font-bold leading-snug text-eq-navy sm:text-base" data-id="element-38" data-mp="1aoiwe5c9ad36">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-eq-gold transition-transform duration-150 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-39" data-mp="11wp98028244m" />
                  </button>
                </h3>
                {isOpen && <p id={panelId} className="px-2.5 pb-2 text-[12px] font-medium leading-snug text-eq-muted sm:text-sm" data-id="element-40" data-mp="wvt7nt5ceu2d">
                    {faq.answer}
                  </p>}
              </article>;
        })}
        </div>
      </div>
    </section>;
}